import React, { useEffect, useState } from 'react';
import { Box, Typography, CircularProgress, Button, Alert } from '@mui/material';
import { exchangeGitHubCode } from '../api/github';

const GitHubCallback: React.FC = () => {
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');

    if (!code) {
      setError('No authorization code received from GitHub');
      return;
    }

    exchangeGitHubCode(code)
      .then(() => {
        window.close();
      })
      .catch((e) => {
        setError(e.response?.data?.detail || e.message || 'Failed to connect GitHub');
      });
  }, []);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh', p: 4 }}>
      {error ? (
        <>
          <Alert severity="error" sx={{ mb: 2, maxWidth: 400 }}>{error}</Alert>
          <Button variant="outlined" onClick={() => window.close()}>Close</Button>
        </>
      ) : (
        <>
          <CircularProgress sx={{ mb: 2 }} />
          <Typography color="text.secondary">Connecting GitHub...</Typography>
        </>
      )}
    </Box>
  );
};

export default GitHubCallback;
